import { render, staticRenderFns } from "./CoozzyMultiselect.vue?vue&type=template&id=b86c4baa&scoped=true"
import script from "./CoozzyMultiselect.vue?vue&type=script&lang=js"
export * from "./CoozzyMultiselect.vue?vue&type=script&lang=js"
import style0 from "./CoozzyMultiselect.vue?vue&type=style&index=0&id=b86c4baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86c4baa",
  null
  
)

export default component.exports